<template>
  <div class="max-w-xs" style="min-width: 15rem">
    <div v-if="loading" class="mb-1 animate-pulse">
      <div class="bg-neutral-90 mb-3 h-1 w-full rounded-xl"></div>
      <div class="mb-1.5 flex justify-between">
        <div class="bg-neutral-90 h-1.5 w-16 rounded-xl"></div>
        <div class="bg-neutral-90 h-1.5 w-12 rounded-xl"></div>
      </div>
    </div>

    <div v-if="!loading" ref="divRef">
      <div class="bg-neutral-95 mb-1 h-1 w-full overflow-hidden rounded-lg">
        <div
          :style="`width: ${filledPerc <= 0 ? 1 : filledPerc >= 100 ? 100 : filledPerc}%`"
          :class="[danger ? 'bg-danger-60' : warning ? 'bg-warning-60' : primary ? 'bg-primary-60' : 'bg-success-60']"
          class="h-1 rounded-lg transition-all duration-300"
        ></div>
      </div>
      <div class="flex justify-between space-x-4 text-sm">
        <div class="text-neutral-40 flex-grow whitespace-nowrap font-normal">
          <slot name="title"></slot>
        </div>
        <div
          :class="[danger ? 'text-danger-60' : warning ? 'text-warning-60' : primary ? 'text-primary-60' : 'text-neutral-40']"
          class="flex-grow-0 whitespace-nowrap font-medium"
        >
          <slot name="description"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef } from "vue";

//Utils
import { useTooltip } from "@composables/tooltips";

const props = withDefaults(
  defineProps<{
    filledPerc: number;
    warning: boolean;
    danger: boolean;
    loading: boolean;
    primary?: boolean;
    tooltip?: string;
  }>(),
  {
    filledPerc: 0,
    warning: false,
    danger: false,
    loading: false,
    tooltip: "",
    primary: false,
  },
);

const divRef = ref();
const contentToRef = toRef(props, "tooltip");
contentToRef.value && useTooltip(divRef, contentToRef, { placement: "bottom-start", zIndex: 9999 });
</script>
